import {Component, Plugins} from '@packages/systems/wfdl';
import {namesEqual, qualify} from '@packages/systems/wfdl-Qualified';
import type {ExpressionElement} from '@packages/systems/wfdl-ast';

const standaloneModalType = qualify(
  Plugins.name('Modal'),
  Component.name('Modal')
);

/** Returns whether an element is a standalone Modal. */
export const isModalTarget = (element: ExpressionElement): boolean =>
  namesEqual(element.type, standaloneModalType);

/**
 * Returns whether an element type is a standalone Modal, for callers that keep
 * only the type of a target.
 */
export const isModalTargetType = (type: ExpressionElement['type']): boolean =>
  namesEqual(type, standaloneModalType);
